"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapmakerStaticUrl = exports.getContentUrl = exports.getContentImageUrl = void 0;
const config_1 = __importDefault(require("@mapmaker/config"));
const isomorphic_base64_1 = require("isomorphic-base64");
// Edits info: https://sharp.pixelplumbing.com/api-resize
// Filter info: https://docs.aws.amazon.com/solutions/latest/serverless-image-handler/appendix-d.html
function getContentImageUrl(key, width, height, fit = "inside") {
    const imageRequest = JSON.stringify({
        bucket: config_1.default.internalBucket,
        key,
        edits: {
            resize: {
                width,
                height,
                fit,
                background: { r: 255, g: 255, b: 255, alpha: 1 },
            },
        },
    });
    return getContentUrl((0, isomorphic_base64_1.btoa)(imageRequest));
}
exports.getContentImageUrl = getContentImageUrl;
function getContentUrl(path) {
    return `${config_1.default.contentUrl}/${path}`;
}
exports.getContentUrl = getContentUrl;
function getMapmakerStaticUrl(path) {
    return `${config_1.default.staticUrl}/${path}`;
}
exports.getMapmakerStaticUrl = getMapmakerStaticUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJDb250ZW50VXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvTWFwbWFrZXJDb250ZW50VXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsOERBQThDO0FBQzlDLHlEQUF5QztBQUV6Qyx5REFBeUQ7QUFDekQscUdBQXFHO0FBQ3JHLFNBQWdCLGtCQUFrQixDQUNoQyxHQUFXLEVBQ1gsS0FBYyxFQUNkLE1BQWUsRUFDZixNQUEyRCxRQUFRO0lBRW5FLE1BQU0sWUFBWSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUM7UUFDbEMsTUFBTSxFQUFFLGdCQUFjLENBQUMsY0FBYztRQUNyQyxHQUFHO1FBQ0gsS0FBSyxFQUFFO1lBQ0wsTUFBTSxFQUFFO2dCQUNOLEtBQUs7Z0JBQ0wsTUFBTTtnQkFDTixHQUFHO2dCQUNILFVBQVUsRUFBRSxFQUFFLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDLEVBQUUsR0FBRyxFQUFFLEtBQUssRUFBRSxDQUFDLEVBQUU7YUFDakQ7U0FDRjtLQUNGLENBQUMsQ0FBQztJQUVILE9BQU8sYUFBYSxDQUFDLElBQUEsd0JBQUksRUFBQyxZQUFZLENBQUMsQ0FBQyxDQUFDO0FBQzNDLENBQUM7QUFwQkQsZ0RBb0JDO0FBRUQsU0FBZ0IsYUFBYSxDQUFDLElBQVk7SUFDeEMsT0FBTyxHQUFHLGdCQUFjLENBQUMsVUFBVSxJQUFJLElBQUksRUFBRSxDQUFDO0FBQ2hELENBQUM7QUFGRCxzQ0FFQztBQUVELFNBQWdCLG9CQUFvQixDQUFDLElBQVk7SUFDL0MsT0FBTyxHQUFHLGdCQUFjLENBQUMsU0FBUyxJQUFJLElBQUksRUFBRSxDQUFDO0FBQy9DLENBQUM7QUFGRCxvREFFQyJ9